export const FallbackComponent = () => (
	<div className="container">
		<div className="tw:relative tw:mt-1.125 tw:block tw:rounded-sm tw:border tw:border-solid tw:border-gray-400 tw:bg-white tw:font-sans tw:shadow-xs">
			<h2 className="tw:block tw:w-full tw:text-center tw:text-noComponentGray-text">
				An error occurred loading the page &#9785;
			</h2>
			<h3 className="tw:block tw:w-full tw:text-center tw:text-noComponentGray-text">
				Please try again
			</h3>
		</div>
	</div>
);
